<template>
  <div class="doc">
    <p class="title">{{ title }}</p>
    <h4 class="title-f">Novermber 14, 2025</h4>
    <div class="text">
      <p>
        At OPay MFB, the privacy of our Data Subjects and their Personal Data is
        of utmost importance to us. And in line with our resolution, we have
        developed this Privacy Policy to explain your privacy rights,
        particularly regarding how we collect, process, retain, share and
        protect your Personal Data when you visit our website, premises or use
        our digital platforms (collectively, "the Platform" or "Services").
      </p>
      <p>
        This Privacy Policy between OPay Microfinance Bank Limited ("OPay MFB")
        and you constitutes our commitment to your continued privacy on all our
        platforms. It is designed to provide information regarding our privacy
        practices and help you understand how we handle your data, in full
        compliance with the provisions of the Nigeria Data Protection Act 2023
        and other applicable data protection regulations.
      </p>
      <p>
        <span class="sub-title">1. Consent</span>
        When you access our platforms and give your consent upon such access,
        you accept this privacy policy; in particular, as you use the services
        offered on our website and digital platform or visit any of our offices
        and submit your data for official or non-official purposes.
      </p>
      <p>
        <span class="sub-title">2. What Personal Data do we collect?</span>
        We collect Personal Data about you when you use the services offered on
        our website and digital platform, including the following: <br />
        <span class="privacy-space"
          ><span class="bold">1. Sign-up information: </span> When you register
          to use the services offered on our digital platform, we will collect
          Personal Data as necessary to offer and fulfil the service you
          request. Depending on the service you choose, in line with regulatory
          requirements for Know Your Customer (KYC) purposes, we may require
          that you provide us with your name, gender, birthday, facial photo,
          residential address, ID information (photo, number), utility bill,
          email address, mobile number, social media handles and debit/credit
          card details to create an account. We will also require your NIN
          and/or your BVN in line with regulation and in furtherance of our KYC
          computation processes. 
        </span>
        <span class="privacy-space"
          >2. We may also require you to provide additional, necessary personal
          details as you use our services.  <br
        /></span>
        <span class="privacy-space"
          ><span class="bold">3. Transaction information:</span> When you use
          our digital platform to access loans, send and receive money, make
          purchases from merchants, pay bills, deposit & withdraw cash, we
          collect information about the transaction, as well as other associated
          information as necessary to offer and fulfil the servicethat we are
          obliged to; such as the loan amount, repayment date, interest and loan
          product, the amount sent or received the amount paid for products or
          services, merchant information – including information about your
          device and geolocation. We may cross-check your identity with third
          parties including the person you have provided as your relationship
          contact. The Contact Information you provide will only be used to
          verify your identity and to reach you in the case of emergency, and
          will NOT be used for loan repayment/collection purposes. Your loan
          information won’t be shared with the contacts. We will also collect
          data from your device for our credit-scoring system. This includes
          information relating to your device, such as device make and model,
          operating system, and installed software applications. To supplement
          this information, we may also collect data from third parties such as
          credit bureaus and other financial institutions. By registering for
          the Services, you authorize the collection and processing of the
          foregoing data.</span
        >
        <span class="privacy-space"
          ><span class="bold">4. Participant Personal Data: </span> When you use
          our services, we may collect Personal Data about the other
          participants associated with the transaction, including your phone
          contacts with your consent, so you can easily transact with your
          friends and contacts and enable instant messaging (IM). We collect
          Personal Data such as name and financial account information about the
          participant who is receiving money from (or sending money to) you when
          you send or receive money through the Services. 
        </span>
        <span class="privacy-space"
          ><span class="bold">5. Image Information:</span> We may collect your
          image (upload, storage, and use) information to support account
          opening, such as uploading your portrait. We may also collect
          information from your images when you use our customer support to
          upload evidence such as statements and checks. In addition, we may
          collect your image information in connection with regulatory KYC
          purposes.
        </span>
        <span class="privacy-space"
          ><span class="bold">6. Information from other sources:</span> We may
          collect information from other sources, such as our social media
          platforms when you reach out to us to lodge a complaint about our
          services. However, we will only ask for information relevant to the
          help required of us to you. 
        </span>
        <span class="privacy-space"
          ><span class="bold"
            >7. Other information we collect related to your use of our website
            or Services:</span
          >
          We may collect additional information from or about you when you
          communicate with us, contact our customer support teams, respond to a
          survey or use functionality offered by third-party service providers
          through our Platform. For instance, when you initiate third-party
          applications through OPay MFB’s mobile application, with your prior
          consent, your SMS may be collected and monitored to help third-party
          service providers reduce risks associated with your application
          through the relevant model/system to provide customized services.
        </span>
        <span class="privacy-space"
          ><span class="bold">8. When you apply for a job with us:</span> We may
          request Personal Data about your education, employment and state of
          health. As part of your application, you will be asked to provide your
          express consent to our use of this information to assess your
          application and any monitoring activities which may be required of us
          under applicable laws as an employer. We may also carry out screening
          checks (including reference, background and criminal record checks).
          We may exchange your Personal Data with academic institutions,
          recruiters, health maintenance organisations, law enforcement
          agencies, referees and your previous employers. Without your Personal
          Data, we may not be able to process your application for positions
          with us.
        </span>
        <span class="privacy-space"
          ><span class="bold"
            >9. We do not collect the information of minors:</span
          >
          If you are under the age of 18, you are not eligible to use the
          service offered on our digital platform.</span
        >
      </p>
      <p>
        <span class="sub-title">3. How Do We Retain Personal Data?</span>
        We retain Personal Data in an identifiable format only for as long as
        required for our business purposes, with specific reference to the
        service rendered to you, and to fulfil our legal or regulatory
        obligations. Subject to applicable law, which might, from time to time,
        oblige us to retain your Personal Data for a certain period of time, we
        will retain your Personal Data for as long as necessary to fulfil the
        purposes we collect it for, including the purposes of satisfying any
        legal, accounting, or reporting obligations.
      </p>
      <p>
        <span class="sub-title">4. How Do We Process Personal Data?</span>
        We collect your personal data to provide you an efficient and secure
        customer experience. We may process your Personal Data for the following
        reasons: <br />
        <span class="privacy-space">1.Provide services, including to: </span>
        <span class="privacy-space"
          ><span class="privacy-space"
            ><span class="circle">·</span>Initiate a payment, send or request
            money, or pay a bill;
          </span></span
        >
        <span class="privacy-space"
          ><span class="privacy-space"
            ><span class="circle">·</span>Authenticate your access to an
            account;
          </span></span
        >
        <span class="privacy-space"
          ><span class="privacy-space"
            ><span class="circle">·</span>Communicate with you about your
            account;
          </span></span
        >
        <span class="privacy-space"
          >2.Manage risk, fraud and abuse of our services and prevent you from
          fraud (by developing and adopting measures of verifying your
          identity). Our risk and fraud tools use personal data, device
          information and geolocation from our Platform that offers services to
          help detect and prevent fraud and abuse of the services.
        </span>
        <span class="privacy-space"
          >3.Comply with our legal and regulatory obligations and to enforce the
          terms of our sites and services, including to comply with all
          applicable laws and regulations.
        </span>
        <span class="privacy-space"
          >4.Trail information breaches and remediate such identified breaches.
        </span>
        <span class="privacy-space"
          >5.Resolve disputes and troubleshoot problems.
        </span>
        <span class="privacy-space">6.With your prior consent: </span>
        <span class="privacy-space"
          ><span class="privacy-space"
            ><span class="circle">·</span>Market OPay MFB’s products and
            services to you.
          </span></span
        >
        <span class="privacy-space"
          ><span class="privacy-space"
            ><span class="circle">·</span>Use cookies to provide a targeted
            display, feature, service or offer to you.
          </span></span
        >
        <span class="privacy-space"
          ><span class="privacy-space"
            ><span class="circle">·</span>To provide you with location-specific
            functionality like searching nearby agents if you authorize us to
            access your Geolocation information through the Services.</span
          ></span
        >
        We will not send unsolicited marketing communications to you by SMS or
        email if you have not opted in to receive them. Additionally, you may
        withdraw your consent at any time and free of charge.
      </p>
      <p>
        <span class="sub-title">5. Sharing your Personal Data</span>
        We may share your Personal Data or other information about you with
        others for the following reasons:
        <span class="privacy-space"
          ><span class="circle">·</span>With other sister companies/affiliates:
          We may share your Personal Data with other entities/affiliates/sister
          companies as necessary to enable the technical service you request, to
          manage risk through risk model system, to prevent potentially illegal
          and fraudulent acts and violations of our policies and agreements, and
          to help us manage the connectivity of our services. We may also share,
          receive and rely on such information necessary to effect debits,
          transfers and redemptions across your accounts with us and our
          affiliates for repayment and mandate purposes.
        </span>
        <span class="privacy-space"
          ><span class="circle">·</span>We may also share, receive and rely on
          such information necessary to effect debits, transfers and redemptions
          across your accounts with us and our affiliates for repayment and
          mandate purposes. ·With other companies that provide services to us:
          We may share Personal Data with third-party service providers that
          perform services and functions at our direction and on our behalf.
          These third-party service providers may, for example, provide you with
          services, verify your identity, assist in processing transactions,
          send you advertisements for our products and services, or provide
          customer support. Rest assured that we make double sure that these
          companies have compliant, legal measures in place to ensure the
          security and confidentiality of your Personal Data.</span
        >
        <span class="privacy-space"
          ><span class="circle">·</span>With unaffiliated third-party service
          providers that offer functionality through our Platform, with your
          prior consent, to help complete the service you request. 
        </span>
        <span class="privacy-space"
          ><span class="circle">·</span>With other financial institutions: We
          may share Personal Data with other financial institutions that we have
          partnered with to offer OPay MFB-related services, unless your consent
          extends to other uses. We may also share Personal Data to process
          transactions and keep your financial information up to date.</span
        >
        <span class="privacy-space"
          ><span class="circle">·</span>With the other parties to transactions
          when you use the services, such as other users and their service
          providers. This includes other users you are sending or receiving
          funds from and their service providers. The information might
          include:</span
        >
        <span class="privacy-space">
          <span class="privacy-space"
            ><span class="circle">·</span>Personal Data and account information
            necessary to facilitate the transaction; and</span
          >
        </span>
        <span class="privacy-space">
          <span class="privacy-space"
            ><span class="circle">·</span>Personal Data to help other
            participant(s) resolve disputes and detect and prevent fraud.</span
          >
        </span>
        <span class="privacy-space">
          <span class="circle">·</span>Where permitted or required by law. We
          may share information about you with other parties for OPay MFB's
          business purposes or as permitted or required by law, including:
        </span>
        <span class="privacy-space">
          <span class="privacy-space"
            ><span class="circle">·</span>If we need to do so to comply with a
            court proceeding, other legal process or an applicable
            regulation;</span
          >
        </span>
        <span class="privacy-space">
          <span class="privacy-space"
            ><span class="circle">·</span>To law enforcement authorities or
            other government officials, or other third parties pursuant to a
            court order or other legal process or requirement applicable to OPay
            MFB or an affiliated entity;</span
          >
        </span>
        <span class="privacy-space">
          <span class="privacy-space"
            ><span class="circle">·</span>Where we reasonably believe that the
            disclosure is necessary or appropriate to prevent imminent physical
            harm or financial loss or in connection with an investigation of
            suspected (or actual) illegal activity;</span
          >
        </span>
        <span class="privacy-space">
          <span class="privacy-space"
            ><span class="circle">·</span>With credit agencies and data
            processors for credit reference checks and anti-fraud and compliance
            purposes – all in accordance to applicable data privacy regulations
            and laws;</span
          >
        </span>
        <span class="privacy-space">
          <span class="privacy-space"
            ><span class="circle">·</span>To investigate violations of or
            enforce a user agreement or other legal terms applicable to any
            service;</span
          >
        </span>
        <span class="privacy-space">
          <span class="privacy-space"
            ><span class="circle">·</span>To protect our property, services and
            legal rights;</span
          >
        </span>
        <span class="privacy-space">
          <span class="privacy-space"
            ><span class="circle">·</span>As reasonably and legally permitted,
            to facilitate a purchase or sale of all or part of OPay MFB's
            business, or in the instance of some merger and acquisition;</span
          >
        </span>
        <span class="privacy-space">
          <span class="privacy-space"
            ><span class="circle">·</span>To support our audit, compliance, and
            corporate governance functions.</span
          >
        </span>
        <span class="privacy-space">
          <span class="circle">·</span>With your consent: We also will share
          your Personal Data and other information with your consent or
          direction.
        </span>
      </p>
      <p>
        <span class="sub-title">6. How We Use Cookies</span>
        Cookies are small files placed on your device’s browser that enable the
        website to identify your device as you view different pages. Like most
        interactive websites, our website uses cookies to enable us track of
        your activity for the duration of a session. Our website uses only
        encrypted session cookies which are erased either after a predefined
        timeout period or once the user logs out of the platform and closes the
        browser. Session cookies do not collect information from your device.
        They will typically store data in the form of a session identification
        that does not personally identify you. Certain aspects of our website
        are only available through the use of cookies, so your use of our
        website may be limited or not possible if you choose to disable or
        decline cookies. If you choose to decline the cookies, you may simply
        exit our website.
      </p>
      <p>
        <span class="sub-title">7. What Are Your Rights?</span>
        <span class="privacy-space bold"
          >1.Requests to Access, Rectify or Erase.</span
        >
        <span class="privacy-space">
          <span class="privacy-space">
            a.Access Request
            <span class="privacy-space">
              As permitted under law and applicable data privacy regulations,
              you have the right to ask us whether we hold any Personal Data
              relating to you and, if we do, to be provided with a copy of that
              Personal Data in electronic form, unless you want to receive it in
              any other way (for example, a paper copy). In addition, you can
              ask us for information on how we use your Personal Data, who we
              share it with, how long we keep it, where it is stored, and other
              information to help you understand how we use it.
            </span>
          </span>
          <span class="privacy-space">
            b.Rectification Request
            <span class="privacy-space">
              You have the right to ask us to correct your Personal Data
              (including by means of providing a supplementary statement) if it
              is inaccurate, or update outdated or incomplete Personal Data
              without undue delay. Where we cannot correct the Personal Data, we
              include a note on our files regarding your request to correct your
              Personal Data.
            </span>
          </span>
          <span class="privacy-space">
            c.Erasure Request
            <span class="privacy-space">
              You have the right to ask us to erase your Personal Data if:
              <span class="privacy-space">
                i.Your Personal Data are no longer necessary for the purpose(s)
                they were collected for. <br />
                ii.Your Personal Data have been unlawfully processed. <br />
                iii.Your Personal Data must be erased to comply with a
                regulation. <br />
                iv.You withdraw your consent for the processing of the Personal
                Data (and if this is the only basis on which we are processing
                your Personal Data). <br />
                v.You object to the possession, provided there are no overriding
                legitimate grounds for continued processing, or <br />
                vi.You object to processing for direct marketing purposes.
              </span>
            </span>
          </span>
          If we receive your erasure request, we will also take reasonable steps
          to inform other data controllers processing the data so they can seek
          to erase links to or copies of your Personal Data. We may refuse to
          act on your request to erase your Personal Data if the processing of
          your Personal Data is necessary:
          <span class="privacy-space">
            d.To exercise our right of freedom of expression and information.
            <br />
            e.To comply with the relevant Nigerian laws and regulations. <br />
            f.For the performance of a task carried out in the public interest
            or to exercise some official authority vested in us. <br />
            g.To establish, exercise or defend legal claims. <br />
            h.to comply with pertinent legal and regulatory directives.
          </span>
          In these cases, we can restrict the processing instead of erasing your
          Personal Data if requested to do so by you.
        </span>
        <span class="privacy-space">
          2.<span class="bold">Requests to Object:</span> You have the right to
          object at any time to the processing of your Personal Data if we
          process it based on our legitimate interests. This includes any
          so-called “profiling”. Our privacy notice informs you when we rely on
          legitimate interests to process your Personal Data. In these cases, we
          will stop processing your Personal Data unless we can demonstrate
          compelling legitimate reasons for continuing the processing. We may
          reject your request if the processing of your Personal Data is needed
          to establish, exercise or defend legal claims. You have the right to
          object at any time if we process your Personal Data for direct
          marketing purposes. You may also object at any time to profiling
          supporting our direct marketing. In such cases, we will stop
          processing your Personal Data when we receive your objection.
        </span>
        <span class="privacy-space">
          3.<span class="bold">Requests to Restrict:</span> You have the right
          to ask us to restrict the processing of your Personal Data if: <br />
          <span class="privacy-space">
            a.You contest the accuracy of your Personal Data and we are in the
            process of verifying the Personal Data we hold. <br />
            b.The processing is unlawful and you do not want us to erase your
            Personal Data. <br />
            c.We no longer need your Personal Data for the original purpose(s)
            of processing, but you need them to establish, exercise or defend
            legal claims and you do not want us to delete the Personal Data as a
            result, or <br />
            d.You have objected to processing carried out because of our
            legitimate interests while we verify if our legitimate grounds
            override yours.
          </span>
          If processing is restricted, we may process your Personal Data
          (excepting for storage purposes), only:
          <span class="privacy-space">
            e.If you have given us your consent. <br />
            f.For establishing, exercising or defending legal claims. <br />
            g.For protecting the rights of another natural or legal person, or
            <br />
            h.For reasons of important public interest as defined under the NDPA
            and relevant Nigerian laws. <br />
            i.to comply with pertinent legal and regulatory directives.
          </span>
          Once processing is restricted following your request, we will inform
          you before we lift the restriction.
        </span>
        <span class="privacy-space">
          4.<span class="bold">Requests for Portability:</span> If our
          processing is performed by computer and is necessary to fulfil a
          contract with you, or is based on your consent, you have the right to:
          <br />
          <span class="privacy-space">
            a.Receive any Personal Data you have provided to us in a structured,
            commonly used and machine-readable electronic format. <br />
            b.Send your Personal Data to another organization or have us do so
            for you if it is technically feasible for us to do so.
          </span>
          If your request relates to a set of Personal Data that also concerns
          other individuals, we may restrict the transfer to only the portion
          relevant to you, unless you establish that you have also gotten their
          consent.
        </span>
        <span class="privacy-space">
          5.<span class="bold">Requests to Object to Automated Decisions:</span>
          Generally, you have the right to object to any legal decision
          concerning you or which otherwise significantly affects you if this is
          based solely on the automated processing of your Personal Data. This
          includes automated decisions based on profiling. In such instance, you
          may undertake a legal process to prevent or advance your rights.
        </span>
        <span class="privacy-space">
          Otherwise, we may refuse your request regarding such automated
          decisions where:
          <span class="privacy-space">
            a.Necessary to enter into a contract with you, or for the
            performance of your contract with us. <br />
            b.Permitted by regulations, or <br />
            c.Based on your explicit consent. <br />
          </span>
          Our actions on the automated processing involving your sensitive
          Personal Data (where you have given your explicit consent or the
          processing is necessary for reasons of substantial public interest),
          are in complete compliance with the NDPA and relevant laws.
        </span>
      </p>
      <p>
        <span class="sub-title">
          8. How Do We Protect Your Personal Data?
        </span>
        <span class="bold">Security</span>
        We maintain technical, physical, and administrative security measures
        designed to provide reasonable protection for your Personal Data against
        loss, misuse, unauthorized access, disclosure, and alteration. The
        security measures include firewalls, data encryption, physical access
        controls to our premises, CCTV cameras for public safety and quality
        control, as well as information access authorization controls. <br />
        <span class="bold">Confidentiality </span>
        Your Personal Data is regarded as confidential and will not be divulged
        to any third party, except under legal and/or regulatory conditions. You
        have the right to request sight of, and copies of any and all
        information we keep on you, if such requests are made in compliance with
        the Freedom of Information Act and other relevant enactments. <br />
        While we are dedicated to securing our systems and services and
        safeguarding the information entrusted to us, your role in fulfilling
        confidentiality duties includes, but is not limited to, adopting and
        enforcing appropriate security measures such as securing and maintaining
        the privacy of your password(s) and account/profile registration
        information, adherence with physical security protocols on our premises,
        verifying that the Personal Data we maintain of you is accurate and
        current. <br />
        We will inform you of any breaches which may affect your Personal Data.
      </p>
      <p>
        <span class="sub-title">
          9. Remedies for Violation and Time-frame for Remedy
        </span>
        In the event of violation of this policy, our Data Protection Officer
        shall within 7 days redress the violation. Where the violation pertains
        to the disclosure of your Personal Data without your consent, such
        information shall be retracted immediately, and confirmation of the
        retraction sent to the you within 48 hours of the redress.
      </p>
      <p>
        <span class="sub-title"> 10. Governing Law </span>
        This Privacy Policy is made according to the Nigeria Data Protection Act
        (2023) or any other relevant Nigerian laws, regulations or international
        conventions applicable to Nigeria.
      </p>
      <p>
        <span class="sub-title"> 11. Changes to our Privacy Policy </span>
        This privacy policy is reviewed periodically and when there is any
        substantial change to business or regulatory requirements. The revised
        Privacy Policy will be effective as of the published updated date. At
        the minimum, we shall review this annually and communicate via our
        communication channels such as Website, Social Media Accounts etc. Your
        continued use of our services after any such change constitutes your
        acceptance of the updated Terms. If the revised version includes a
        substantial change, we may notify you of the change using emails or
        other means.
      </p>
      <p>
        <span class="sub-title">
          12. How Does Your Personal Data Move Globally?
        </span>
        Our operations are supported by a network of computers, cloud-based
        services and other infrastructure and information technology. Your
        Personal Data will be stored in Nigeria where we are providing Services
        to you, except where you provide your consent for your Personal Data to
        be processed outside Nigeria to enable us process your transactions.
        Data are stored with appropriate encryption menthod and security
        standards. We will protect your information as prescribed in the Privacy
        Policy if your Personal Data is transferred out of Nigeria. By using our
        Platform and Services, you consent to your Personal Data being
        transferred out of Nigeria, to a jurisdiction which has adequate data
        protection laws as prescribed in the NDPA.
      </p>
      <p>
        <span class="sub-title">
          13. Assignment on Merger or Acquisition.
        </span>
        In the event that OPay MFB undergoes a merger, acquisition, corporate
        reorganization, or sale of all or substantially all of its assets or
        business, all rights and obligations arising under these Terms and
        Conditions shall automatically be assigned to, assumed by, and continue
        to be enforceable against and by the successor or acquiring entity,
        without the need for further consent from you. Such successor or
        acquiring entity shall be deemed substituted for OPay MFB for all
        purposes under these Terms and Conditions.
      </p>
      <p>
        <span class="sub-title"> 14.Contact Us </span>
        If you have any general questions or concerns about this Privacy Policy
        or the way in which we handle your Personal Data, kindly contact us via
        the details below:  <br />
        <br />
        <span class="bold">OPay Microfinance Bank Limited</span> <br />
        <br />
        6 Adeniyi Jones, Ikeja, Lagos, Nigeria. <br /><br />
        Email: help.opaymfb@opaymfb.com
      </p>
    </div>
  </div>
</template>
<style></style>
<script>
export default {
  name: "privacyCom",
  props: {
    title: {
      type: String,
      default: "PRIVACY POLICY",
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
